import { useCallback, useContext, useEffect, useState } from 'react';
import { TaskDetailContext } from 'shared/contexts/task-detail/task-detail-context';
import { useKeysDown } from 'shared/hooks/use-keys-down';

export const useTaskDetailSubmenu = () => {
  const { setSubmenuOpen } = useContext(TaskDetailContext);
  const [menuOpen, setMenuOpen] = useState(false);

  const openMenu = useCallback(() => {
    setMenuOpen(true);
    setSubmenuOpen(true);
  }, [setSubmenuOpen]);

  const closeMenu = useCallback(() => {
    setMenuOpen(false);
    setSubmenuOpen(false);
  }, [setSubmenuOpen]);

  useEffect(() => {
    return () => {
      if (menuOpen) {
        setSubmenuOpen(false);
      }
    };
  }, [menuOpen, setSubmenuOpen]);

  useKeysDown(
    ['Escape'],
    (e: KeyboardEvent) => {
      if (menuOpen) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        closeMenu();
      }
    },
    { capture: true, ignoreInputFields: false },
  );

  return {
    menuOpen,
    openMenu,
    closeMenu,
  };
};
